// Shared UI helpers for the Lot Detail page (extracted from LotDetailPage.js).
import React from 'react';
import { Badge } from '../ui/badge';

export const getStatusBadge = (status) => {
  const styles = {
    open: 'bg-sky-500 text-white',
    in_progress: 'bg-amber-500 text-white',
    suspended: 'bg-red-500 text-white',
    closed: 'bg-slate-400 text-white',
    pending: 'bg-slate-300 text-slate-700',
    completed: 'bg-emerald-500 text-white',
    to_do: 'bg-slate-300 text-slate-700',
    blocked: 'bg-red-500 text-white',
  };
  return styles[status] || styles.pending;
};

export const deliveryStatusBadge = (status) => {
  const map = {
    da_consegnare: { label: 'Da consegnare', cls: 'bg-amber-500 text-white' },
    parzialmente_consegnato: { label: 'Parzialmente consegnato', cls: 'bg-sky-500 text-white' },
    consegnato: { label: 'Consegnato', cls: 'bg-emerald-600 text-white' },
  };
  const v = map[status] || map.da_consegnare;
  return <Badge className={`${v.cls} px-3 py-1`}>{v.label}</Badge>;
};
